import React, { useEffect, useState } from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import PropTypes from 'prop-types';

// Animation CSS
const styleSheet = document.createElement('style');
styleSheet.textContent = `
    @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }
`;
document.head.appendChild(styleSheet);

// Styles pour le composant
const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px'
    },
    modal: {
        backgroundColor: 'white',
        borderRadius: '8px',
        width: '100%',
        maxWidth: '800px',
        maxHeight: '90vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px 24px',
        borderBottom: '1px solid #e5e7eb',
        backgroundColor: '#f9fafb'
    },
    title: {
        margin: 0,
        fontSize: '20px',
        fontWeight: '600',
        color: '#111827'
    },
    closeButton: {
        background: 'none',
        border: 'none',
        fontSize: '24px',
        cursor: 'pointer',
        color: '#6b7280',
        padding: '4px 8px',
        borderRadius: '4px'
    },
    tabContainer: {
        display: 'flex',
        borderBottom: '1px solid #e5e7eb',
        backgroundColor: '#f9fafb'
    },
    tab: {
        flex: 1,
        padding: '12px 16px',
        border: 'none',
        backgroundColor: 'transparent',
        color: '#6b7280',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        transition: 'all 0.2s',
        borderBottom: '2px solid transparent'
    },
    activeTab: {
        color: '#2563eb',
        borderBottomColor: '#2563eb',
        backgroundColor: 'white'
    },
    content: {
        flex: 1,
        overflowY: 'auto',
        padding: '24px'
    },
    loadingContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px',
        color: '#6b7280'
    },
    spinner: {
        width: '40px',
        height: '40px',
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #2563eb',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginBottom: '15px'
    },
    errorContainer: {
        backgroundColor: '#fef2f2',
        border: '1px solid #fecaca',
        borderRadius: '6px',
        padding: '16px',
        marginBottom: '20px',
        textAlign: 'center'
    },
    errorText: {
        color: '#dc2626',
        margin: '0 0 12px 0',
        fontSize: '14px'
    },
    retryButton: {
        backgroundColor: '#dc2626',
        color: 'white',
        border: 'none',
        padding: '8px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px'
    },
    profileContainer: {
        maxWidth: '100%'
    },
    infoGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '16px'
    },
    infoItem: {
        padding: '16px',
        backgroundColor: '#f9fafb',
        borderRadius: '6px',
        border: '1px solid #e5e7eb'
    },
    label: {
        display: 'block',
        fontSize: '12px',
        fontWeight: '600',
        color: '#6b7280',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: '8px'
    },
    value: {
        fontSize: '16px',
        color: '#111827',
        fontWeight: '500',
        wordWrap: 'break-word'
    },
    numeroContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
    },
    hiddenValue: {
        fontSize: '16px',
        color: '#6b7280',
        fontWeight: '500',
        letterSpacing: '2px'
    },
    numeroVerifyContainer: {
        display: 'flex',
        gap: '8px',
        alignItems: 'center'
    },
    numeroInput: {
        flex: 1,
        padding: '8px 12px',
        border: '1px solid #d1d5db',
        borderRadius: '4px',
        fontSize: '14px',
        boxSizing: 'border-box'
    },
    verifyButton: {
        backgroundColor: '#2563eb',
        color: 'white',
        border: 'none',
        padding: '8px 16px',
        borderRadius: '4px',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        whiteSpace: 'nowrap'
    },
    numeroError: {
        color: '#dc2626',
        fontSize: '12px',
        marginTop: '4px'
    },
    numeroVisibleContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px'
    },
    hideButton: {
        backgroundColor: '#6b7280',
        color: 'white',
        border: 'none',
        padding: '6px 12px',
        borderRadius: '4px',
        fontSize: '12px',
        cursor: 'pointer',
        whiteSpace: 'nowrap'
    },
    securityContainer: {
        maxWidth: '400px',
        margin: '0 auto'
    },
    sectionTitle: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#111827',
        marginBottom: '20px',
        textAlign: 'center'
    },
    userInfo: {
        backgroundColor: '#f0f9ff',
        border: '1px solid #bae6fd',
        borderRadius: '6px',
        padding: '12px',
        marginBottom: '20px'
    },
    userInfoText: {
        margin: 0,
        fontSize: '14px',
        color: '#0369a1'
    },
    errorMessage: {
        backgroundColor: '#fef2f2',
        color: '#dc2626',
        padding: '12px',
        borderRadius: '6px',
        border: '1px solid #fecaca',
        marginBottom: '16px',
        fontSize: '14px'
    },
    successMessage: {
        backgroundColor: '#f0fdf4',
        color: '#166534',
        padding: '12px',
        borderRadius: '6px',
        border: '1px solid #bbf7d0',
        marginBottom: '16px',
        fontSize: '14px'
    },
    formGroup: {
        marginBottom: '20px'
    },
    inputContainer: {
        position: 'relative'
    },
    input: {
        width: '100%',
        padding: '12px 40px 12px 12px',
        border: '1px solid #d1d5db',
        borderRadius: '6px',
        fontSize: '16px',
        boxSizing: 'border-box'
    },
    eyeButton: {
        position: 'absolute',
        right: '12px',
        top: '50%',
        transform: 'translateY(-50%)',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontSize: '16px',
        padding: '4px'
    },
    submitButton: {
        width: '100%',
        backgroundColor: '#2563eb',
        color: 'white',
        border: 'none',
        padding: '12px 16px',
        borderRadius: '6px',
        fontSize: '16px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'background-color 0.2s'
    },
    buttonDisabled: {
        backgroundColor: '#9ca3af',
        cursor: 'not-allowed'
    },
    footer: {
        padding: '16px 24px',
        borderTop: '1px solid #e5e7eb',
        backgroundColor: '#f9fafb'
    },
    footerButton: {
        width: '100%',
        backgroundColor: '#6b7280',
        color: 'white',
        border: 'none',
        padding: '12px 16px',
        borderRadius: '6px',
        fontSize: '16px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'background-color 0.2s'
    }
};

const SettingsModal = ({ userId, show, onClose, userEmail, userName }) => {
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [foundUserId, setFoundUserId] = useState(null);
    const [activeTab, setActiveTab] = useState('profile');
    const [showNumero, setShowNumero] = useState(false);
    const [numeroPassword, setNumeroPassword] = useState('');
    const [numeroError, setNumeroError] = useState(null);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState(null);
    const [passwordSuccess, setPasswordSuccess] = useState(null);
    const [passwordLoading, setPasswordLoading] = useState(false);
    const [showPasswords, setShowPasswords] = useState({
        current: false,
        new: false,
        confirm: false
    });

    // Initialisation Firebase
    const db = firebase.firestore();
    const auth = firebase.auth();
    const currentUser = auth.currentUser;

    // Récupération des données utilisateur
    useEffect(() => {
        if (!show) return;
        
        setLoading(true);
        setError(null);

        const fetchUserData = async () => {
            try {
                // Vérifier que Firestore est disponible
                if (!db) {
                    throw new Error('Service de base de données non disponible. Veuillez réessayer plus tard.');
                }

                let userDoc = null;
                let actualUserId = null;

                // Stratégie 1: Utiliser userId si disponible
                if (userId) {
                    userDoc = await db.collection('users').doc(userId).get();
                    if (userDoc.exists) {
                        actualUserId = userId;
                    }
                }

                // Stratégie 2: Rechercher par email si userId ne fonctionne pas
                if (!userDoc?.exists && userEmail) {
                    const emailQuery = await db.collection('users')
                        .where('email', '==', userEmail)
                        .limit(1)
                        .get();
                    
                    if (!emailQuery.empty) {
                        userDoc = emailQuery.docs[0];
                        actualUserId = userDoc.id;
                    }
                }

                // Stratégie 3: Rechercher par currentUser.email si disponible
                if (!userDoc?.exists && currentUser?.email) {
                    const currentUserQuery = await db.collection('users')
                        .where('email', '==', currentUser.email)
                        .limit(1)
                        .get();
                    
                    if (!currentUserQuery.empty) {
                        userDoc = currentUserQuery.docs[0];
                        actualUserId = userDoc.id;
                    }
                }

                // Stratégie 4: Utiliser currentUser.uid si disponible
                if (!userDoc?.exists && currentUser?.uid) {
                    userDoc = await db.collection('users').doc(currentUser.uid).get();
                    if (userDoc.exists) {
                        actualUserId = currentUser.uid;
                    }
                }

                if (!userDoc?.exists) {
                    throw new Error('Aucun utilisateur trouvé dans la base de données. Veuillez vous reconnecter.');
                }

                const userData = userDoc.data();
                setFoundUserId(actualUserId);

                const formatDate = (val) => {
                    if (!val) return 'Non défini';

                    try {
                        const date = val.toDate ? val.toDate() :
                            val._seconds ? new Date(val._seconds * 1000) :
                                new Date(val);

                        return date.toLocaleString('fr-FR', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                        });
                    } catch (e) {

                        return 'Date invalide';
                    }
                };

                setUserData({
                    name: userData.name || 'Non renseigné',
                    numero: userData.numero || 'Non attribué',
                    profession: userData.profession || 'Non renseigné',
                    professionalData: userData.professionalData || 'Non renseigné',
                    telephone: userData.telephone || 'Non renseigné',
                    email: userData.email || currentUser?.email || 'Non disponible',
                    lastAccess: formatDate(userData.lastAccess),
                    subscription: {
                        planName: userData.subscription?.plan || 'Gratuit',
                        status: userData.subscription?.active ? 'Actif' : 'Inactif',
                        amount: userData.subscription?.amount || 0,
                        currency: userData.subscription?.currency || 'FCFA',
                        startDate: formatDate(userData.subscription?.startDate),
                        endDate: formatDate(userData.subscription?.endDate)
                    }
                });

            } catch (err) {

                setError(`Erreur: ${err.message}`);
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, [userId, show, db, currentUser]);

    // Fonction pour changer le mot de passe
    const handlePasswordChange = async () => {
        setPasswordError(null);
        setPasswordSuccess(null);

        if (!currentPassword || !newPassword || !confirmPassword) {
            setPasswordError('Tous les champs sont obligatoires');
            return;
        }
        if (newPassword !== confirmPassword) {
            setPasswordError('Le nouveau mot de passe et la confirmation ne correspondent pas');
            return;
        }
        if (newPassword.length < 6) {
            setPasswordError('Le nouveau mot de passe doit contenir au moins 6 caractères');
            return;
        }

        if (!currentUser) {
            setPasswordError('Utilisateur non connecté');
            return;
        }

        setPasswordLoading(true);

        try {
            const credential = firebase.auth.EmailAuthProvider.credential(
                currentUser.email,
                currentPassword
            );

            await currentUser.reauthenticateWithCredential(credential);
            await currentUser.updatePassword(newPassword);
            setPasswordSuccess('Mot de passe modifié avec succès');
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');

        } catch (err) {
            let errorMessage = 'Erreur lors du changement de mot de passe';
            switch (err.code) {
                case 'auth/wrong-password':
                    errorMessage = 'Le mot de passe actuel est incorrect';
                    break;
                case 'auth/weak-password':
                    errorMessage = 'Le nouveau mot de passe est trop faible';
                    break;
                case 'auth/requires-recent-login':
                    errorMessage = 'Veuillez vous reconnecter avant de changer votre mot de passe';
                    break;
                default:
                    errorMessage = err.message || 'Erreur inconnue';
            }
            setPasswordError(errorMessage);
        } finally {
            setPasswordLoading(false);
        }
    };

    const togglePasswordVisibility = (field) => {
        setShowPasswords(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const verifyPasswordForNumero = async () => {
        setNumeroError(null);

        if (!numeroPassword) {
            setNumeroError('Veuillez saisir votre mot de passe');
            return;
        }

        if (!currentUser) {
            setNumeroError('Utilisateur non connecté');
            return;
        }

        try {
            const credential = firebase.auth.EmailAuthProvider.credential(
                currentUser.email,
                numeroPassword
            );

            await currentUser.reauthenticateWithCredential(credential);
            setShowNumero(true);
            setNumeroPassword('');

        } catch (err) {
            let errorMessage = 'Erreur lors de la vérification';
            if (err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
                errorMessage = 'Mot de passe incorrect';
            }

            setNumeroError(errorMessage);
        }
    };

    if (!show) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <div style={styles.header}>
                    <h2 style={styles.title}>Paramètres du profil</h2>
                    <button onClick={onClose} style={styles.closeButton}>
                        ×
                    </button>
                </div>

                <div style={styles.tabContainer}>
                    <button
                        onClick={() => setActiveTab('profile')}
                        style={{
                            ...styles.tab,
                            ...(activeTab === 'profile' ? styles.activeTab : {})
                        }}
                    >
                        Informations personnelles
                    </button>
                    <button
                        onClick={() => setActiveTab('security')}
                        style={{
                            ...styles.tab,
                            ...(activeTab === 'security' ? styles.activeTab : {})
                        }}
                    >
                        Sécurité
                    </button>
                </div>

                <div style={styles.content}>
                    {loading && (
                        <div style={styles.loadingContainer}>
                            <div style={styles.spinner}></div>
                            <p>Chargement...</p>
                        </div>
                    )}

                    {error && (
                        <div style={styles.errorContainer}>
                            <p style={styles.errorText}>{error}</p>
                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                            <button
                                    onClick={() => {
                                        setError(null);
                                        setLoading(true);
                                        // Forcer le rechargement des données avec la même logique robuste
                                        const retryFetchUserData = async () => {
                                            try {
                                                if (!db) {
                                                    throw new Error('Service de base de données non disponible.');
                                                }

                                                let userDoc = null;
                                                let actualUserId = null;

                                                // Essayer userId d'abord
                                                if (userId) {
                                                    userDoc = await db.collection('users').doc(userId).get();
                                                    if (userDoc.exists) actualUserId = userId;
                                                }

                                                // Essayer par email
                                                if (!userDoc?.exists && userEmail) {
                                                    const emailQuery = await db.collection('users')
                                                        .where('email', '==', userEmail)
                                                        .limit(1)
                                                        .get();
                                                    if (!emailQuery.empty) {
                                                        userDoc = emailQuery.docs[0];
                                                        actualUserId = userDoc.id;
                                                    }
                                                }

                                                // Essayer currentUser.email
                                                if (!userDoc?.exists && currentUser?.email) {
                                                    const currentUserQuery = await db.collection('users')
                                                        .where('email', '==', currentUser.email)
                                                        .limit(1)
                                                        .get();
                                                    if (!currentUserQuery.empty) {
                                                        userDoc = currentUserQuery.docs[0];
                                                        actualUserId = userDoc.id;
                                                    }
                                                }

                                                if (!userDoc?.exists) {
                                                    throw new Error('Utilisateur non trouvé dans la base de données.');
                                                }

                                                const userData = userDoc.data();
                                                setFoundUserId(actualUserId);
                                                setUserData({
                                                    name: userData.name || 'Non renseigné',
                                                    numero: userData.numero || 'Non attribué',
                                                    profession: userData.profession || 'Non renseigné',
                                                    professionalData: userData.professionalData || 'Non renseigné',
                                                    telephone: userData.telephone || 'Non renseigné',
                                                    email: userData.email || currentUser?.email || 'Non disponible',
                                                    subscription: {
                                                        planName: userData.subscription?.planName || 'Gratuit',
                                                        status: userData.subscription?.active ? 'Actif' : 'Inactif',
                                                        amount: userData.subscription?.amount || 0,
                                                        currency: userData.subscription?.currency || 'FCFA'
                                                    }
                                                });
                                            } catch (err) {
                                                setError(`Erreur: ${err.message}`);
                                            } finally {
                                                setLoading(false);
                                            }
                                        };
                                        retryFetchUserData();
                                    }}
                                style={styles.retryButton}
                            >
                                Réessayer
                            </button>
                                {error.includes('reconnecter') && (
                                    <button
                                        onClick={() => {
                                            // Rediriger vers la page de connexion
                                            window.location.href = '/';
                                        }}
                                        style={{
                                            ...styles.retryButton,
                                            backgroundColor: '#3498db'
                                        }}
                                    >
                                        Se reconnecter
                                    </button>
                                )}
                            </div>
                        </div>
                    )}

                    {userData && !loading && !error && (
                        <>
                            {activeTab === 'profile' && (
                                <div style={styles.profileContainer}>
                                    <div style={styles.infoGrid}>
                                        <div style={styles.infoItem}>
                                            <label style={styles.label}>Nom complet</label>
                                            <div style={styles.value}>{userData.name}</div>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <label style={styles.label}>N° d&apos;inscription</label>
                                            {!showNumero ? (
                                                <div style={styles.numeroContainer}>
                                                    <div style={styles.hiddenValue}>••••••••</div>
                                                    <div style={styles.numeroVerifyContainer}>
                                                        <input
                                                            type="password"
                                                            placeholder="Mot de passe pour voir le numéro"
                                                            value={numeroPassword}
                                                            onChange={(e) => setNumeroPassword(e.target.value)}
                                                            style={styles.numeroInput}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    verifyPasswordForNumero();
                                                                }
                                                            }}
                                                        />
                                                        <button
                                                            onClick={verifyPasswordForNumero}
                                                            style={styles.verifyButton}
                                                        >
                                                            Voir
                                                        </button>
                                                    </div>
                                                    {numeroError && (
                                                        <div style={styles.numeroError}>{numeroError}</div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div style={styles.numeroVisibleContainer}>
                                                    <div style={styles.value}>{userData.numero}</div>
                                                    <button
                                                        onClick={() => setShowNumero(false)}
                                                        style={styles.hideButton}
                                                    >
                                                        Masquer
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                        <div style={styles.infoItem}>
                                            <label style={styles.label}>Structure</label>
                                            <div style={styles.value}>{userData.profession}</div>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <label style={styles.label}>Section</label>
                                            <div style={styles.value}>{userData.professionalData}</div>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <label style={styles.label}>Téléphone</label>
                                            <div style={styles.value}>{userData.telephone}</div>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <label style={styles.label}>Email</label>
                                            <div style={styles.value}>{userData.email}</div>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <label style={styles.label}>Dernier accès</label>
                                            <div style={styles.value}>{userData.lastAccess}</div>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <label style={styles.label}>Plan d&apos;abonnement</label>
                                            <div style={styles.value}>{userData.subscription.planName}</div>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <label style={styles.label}>Statut</label>
                                            <div style={{
                                                ...styles.value,
                                                color: userData.subscription.status === 'Actif' ? '#22c55e' : '#ef4444'
                                            }}>
                                                {userData.subscription.status}
                                            </div>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <label style={styles.label}>Montant</label>
                                            <div style={styles.value}>
                                                {userData.subscription.amount} {userData.subscription.currency}
                                            </div>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <label style={styles.label}>Début d&apos;abonnement</label>
                                            <div style={styles.value}>{userData.subscription.startDate}</div>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <label style={styles.label}>Fin d&apos;abonnement</label>
                                            <div style={styles.value}>{userData.subscription.endDate}</div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'security' && (
                                <div style={styles.securityContainer}>
                                    <h3 style={styles.sectionTitle}>Modifier le mot de passe</h3>

                                    {!currentUser && (
                                        <div style={styles.errorMessage}>
                                            Utilisateur non connecté. Veuillez vous reconnecter.
                                        </div>
                                    )}

                                    {passwordError && (
                                        <div style={styles.errorMessage}>
                                            {passwordError}
                                        </div>
                                    )}

                                    {passwordSuccess && (
                                        <div style={styles.successMessage}>
                                            {passwordSuccess}
                                        </div>
                                    )}

                                    {currentUser && (
                                        <>
                                            <div style={styles.userInfo}>
                                                <p style={styles.userInfoText}>
                                                    Connecté en tant que: <strong>{currentUser.email}</strong>
                                                </p>
                                            </div>

                                            <div style={styles.formGroup}>
                                                <label style={styles.label}>Mot de passe actuel</label>
                                                <div style={styles.inputContainer}>
                                                    <input
                                                        type={showPasswords.current ? "text" : "password"}
                                                        value={currentPassword}
                                                        onChange={(e) => setCurrentPassword(e.target.value)}
                                                        style={styles.input}
                                                        placeholder="Mot de passe actuel"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => togglePasswordVisibility('current')}
                                                        style={styles.eyeButton}
                                                    >
                                                        {showPasswords.current ? '🙈' : '👁️'}
                                                    </button>
                                                </div>
                                            </div>

                                            <div style={styles.formGroup}>
                                                <label style={styles.label}>Nouveau mot de passe</label>
                                                <div style={styles.inputContainer}>
                                                    <input
                                                        type={showPasswords.new ? "text" : "password"}
                                                        value={newPassword}
                                                        onChange={(e) => setNewPassword(e.target.value)}
                                                        style={styles.input}
                                                        placeholder="Nouveau mot de passe (min. 6 caractères)"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => togglePasswordVisibility('new')}
                                                        style={styles.eyeButton}
                                                    >
                                                        {showPasswords.new ? '🙈' : '👁️'}
                                                    </button>
                                                </div>
                                            </div>

                                            <div style={styles.formGroup}>
                                                <label style={styles.label}>Confirmer le nouveau mot de passe</label>
                                                <div style={styles.inputContainer}>
                                                    <input
                                                        type={showPasswords.confirm ? "text" : "password"}
                                                        value={confirmPassword}
                                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                                        style={styles.input}
                                                        placeholder="Confirmer le mot de passe"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => togglePasswordVisibility('confirm')}
                                                        style={styles.eyeButton}
                                                    >
                                                        {showPasswords.confirm ? '🙈' : '👁️'}
                                                    </button>
                                                </div>
                                            </div>

                                            <button
                                                onClick={handlePasswordChange}
                                                disabled={passwordLoading || !currentUser}
                                                style={{
                                                    ...styles.submitButton,
                                                    ...(passwordLoading || !currentUser ? styles.buttonDisabled : {})
                                                }}
                                            >
                                                {passwordLoading ? 'Modification en cours...' : 'Modifier le mot de passe'}
                                            </button>
                                        </>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </div>

                <div style={styles.footer}>
                    <button onClick={onClose} style={styles.footerButton}>
                        Fermer
                    </button>
                </div>
            </div>
        </div>
    );
};

SettingsModal.propTypes = {
    userId: PropTypes.string,
    userEmail: PropTypes.string,
    userName: PropTypes.string,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

export default SettingsModal;

